// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"OrderHeader_wrapperComponent__ZSSDd","label":"OrderHeader_label__jcZ8-","title":"OrderHeader_title__6rnvG"};